import React, { PropTypes } from 'react'

import './AliadaProfileCard.scss'
import Avatar from 'components/Avatar'
import AliadaBasicInfo from 'components/AliadaBasicInfo'
import ServicePrice from 'components/ServicePrice'
import { URGENT_ALIADA_ID } from '@src/globals'

const AliadaProfileCard = (props) => {
  const {
    avatar,
    info,
    price,
    aliada,
    estimatedServiceHours,
    promoCode
  } = props

  const isUrgentService = aliada.id == URGENT_ALIADA_ID

  return (
    <div className='AliadaProfileCard'>
      {avatar && <Avatar image={aliada.profilePicture.original} superaliada={aliada.superaliada} size={avatar.size} />}
      {info &&
        <AliadaBasicInfo
          firstName={aliada.firstName}
          lastName={aliada.lastName}
          rating={!isUrgentService && aliada.averageRating}
          finishedServicesCount={!isUrgentService && aliada.finishedServicesCount}
          cancellationsCount={!isUrgentService && aliada.cancellationsCount}
          />
      }
      {price && <ServicePrice aliada={aliada}
                              estimatedServiceHours={!isUrgentService && estimatedServiceHours}
                              promoCode={promoCode} />}
    </div>
  )
}

AliadaProfileCard.displayName = 'AliadaProfileCard'
AliadaProfileCard.propTypes = {
  avatar: PropTypes.oneOfType([
    PropTypes.shape({
      size: PropTypes.number
    }),
    PropTypes.bool
  ]),
  info: PropTypes.bool,
  price: PropTypes.bool,
  aliada: PropTypes.shape({
    profilePicture: PropTypes.object,
    superaliada: PropTypes.bool,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string,
    averageRating: PropTypes.number.isRequired,
    finishedServicesCount: PropTypes.number.isRequired,
    serviceCost: PropTypes.number.isRequired
  }),
  estimatedServiceHours: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  promoCode: PropTypes.object
}
AliadaProfileCard.defaultProps = {
  avatar: {
    size: null
  },
  info: true,
  price: true
}

export default AliadaProfileCard



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/AliadaProfileCard/AliadaProfileCard.js